var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('el-switch',{model:{value:(_vm.chance),callback:function ($$v) {_vm.chance=$$v},expression:"chance"}}),_c('div',{staticClass:"title"},[_vm._v("Occasion")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }